import classNames from 'classnames'
import React from 'react'

import { ResponsiveObject, useResponsiveProps } from '../helper/hooks/use-responsive-props.js'

export interface SpinnerProps {
    className?: string
    height?: number
    responsive?: ResponsiveObject<ResponsiveSpinnerProps>[]
    size?: 'medium' | 'large'
    variant?: 'inverted' | 'secondary' | 'light' | 'dark' | 'inherit'
}

export interface ResponsiveSpinnerProps {
    height?: number
}

export type SpinnerResponsiveProps = SpinnerProps & {
    responsive: ResponsiveObject<ResponsiveSpinnerProps>[]
}

export const Spinner = (props: SpinnerProps): JSX.Element => {
    const { responsive, ...rest } = props

    return responsive ? <SpinnerResponsive {...rest} responsive={responsive} /> : <SpinnerInner {...rest} />
}

const SpinnerResponsive = (props: SpinnerResponsiveProps) => {
    const { responsive, ...rest } = props
    const responsiveProps = useResponsiveProps<ResponsiveSpinnerProps>({
        responsive,
    })

    return <SpinnerInner {...rest} {...responsiveProps} />
}

const SpinnerInner = (props: SpinnerProps): JSX.Element => {
    const className: string = classNames(
        'spinner',
        {
            'spinner--height': props.height,
            [`spinner--variant-${props.variant}`]: props.variant,
            [`spinner--size-${props.size}`]: props.size,
        },
        props.className,
    )

    const getStyle = () => {
        if (props.height) {
            return {
                height: props.height,
            }
        }
    }

    return (
        <span className={className} style={getStyle()}>
            <svg className="spinner__circle" viewBox="0 0 48 48" focusable="false">
                <path
                    className="spinner__path"
                    fill="none"
                    d="M24 8C15.16 8 8 15.16 8 24s7.16 16 16 16v4C12.95 44 4 35.05 4 24S12.95 4 24 4s20 8.95 20 20h-4c0-8.84-7.16-16-16-16Z"
                />
            </svg>
        </span>
    )
}
